import { IFilter, IFilterState } from "VSSUI/Utilities/Filter";

/**
 * Update filter state using the given mapping of current filter states
 */
export function updateFilterState(
    filterStates: IDictionaryStringTo<IFilterState>,
    oldIterationId: string,
    newIterationId: string,
    filter: IFilter,
    onSaveFilterState: (filterState: IFilterState) => void
): void {
    // save filter state for old iteration
    if (oldIterationId) {
        filterStates[oldIterationId] = filter.getState();
    }

    // set filter state for selected iteration if it exists
    const newFilterState = filterStates[newIterationId];
    if (newFilterState) {
        filter.setState(newFilterState, /** suppressChangeEvent */ true);
    } else {
        filter.reset(/** suppressChangeEvent */ true);
    }
    
    // persist filter state between page loads
    onSaveFilterState(filter.getState());
}